import { Accordion, Banner, Button, Layout, Text } from '@loadsmart/loadsmart-ui'
import Loading from 'atoms/Loading'
import { toast } from 'atoms/Toast'
import LSDate, { DATE_FORMAT_MMDDYYYYHHMM } from 'common/Date.helpers'
import { removeToken } from 'common/helpers/removeToken'
import { GatewaySettingHistory } from 'common/types/kraken-core/GatewaySettings'
import ErrorPanel from 'molecules/ErrorPanel'
import { useEffect } from 'react'
import ReactDiffViewer, { DiffMethod } from 'react-diff-viewer'
import { useGetGatewaySettingsHistory, useRevertGatewayHistory } from '../api'

export interface GatewaySettingsHistoryProps {
  id: string
}

function HistoryComponent({ id }: GatewaySettingsHistoryProps) {
  const {
    isLoading: isLoadingHistory,
    error: errorHistory,
    data: dataHistory,
  } = useGetGatewaySettingsHistory({ id })

  const parseHistory = (history?: GatewaySettingHistory): string => {
    if (!history) return ''

    const { ...rest } = history

    return JSON.stringify(rest, null, 2)
  }

  const {
    mutate: revert,
    isSuccess: revertSuccess,
    error: revertError,
    reset: revertDataReset,
  } = useRevertGatewayHistory()

  const handleRevert = (history: GatewaySettingHistory) => {
    revert(history)
  }

  useEffect(() => {
    if (revertSuccess) {
      toast.success('Gateway history sucessfully reverted')
      revertDataReset()
    }
  }, [revertSuccess])

  return (
    <Accordion>
      <Accordion.Toggle>
        <Text>History</Text>
      </Accordion.Toggle>
      <Accordion.Body>
        {isLoadingHistory ? (
          <Loading className="justify-center" />
        ) : errorHistory || revertError ? (
          <ErrorPanel error={removeToken(JSON.stringify(errorHistory || revertError, null, 2))} />
        ) : (
          !!dataHistory &&
          dataHistory.map((history, index) => (
            <Accordion key={history.history_id}>
              <Accordion.Toggle>
                <Layout.Group>
                  {history.history_id}
                  {' - '}
                  {LSDate(history.history_date)?.format(DATE_FORMAT_MMDDYYYYHHMM)}
                  {history.history_user && ` by ${history.history_user}`}
                </Layout.Group>
              </Accordion.Toggle>

              <Accordion.Body>
                <Button variant="primary" onClick={() => handleRevert(history)}>
                  Revert
                </Button>

                {history.history_change_reason && (
                  <Banner
                    title={history.history_change_reason}
                    variant="warning"
                    dismissible={false}
                    className="mt-4 mb-4"
                  />
                )}

                <ReactDiffViewer
                  splitView
                  hideLineNumbers
                  oldValue={parseHistory(dataHistory?.[index + 1])}
                  newValue={parseHistory(history)}
                  compareMethod={DiffMethod.TRIMMED_LINES}
                  styles={{
                    line: {
                      fontSize: 12,
                    },
                  }}
                />
              </Accordion.Body>
            </Accordion>
          ))
        )}
      </Accordion.Body>
    </Accordion>
  )
}

export default HistoryComponent
